import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {"float":"left"},
  class: "with-logo"
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Payment Status Portal ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "header-dropdown",
  style: {"color":"white"},
  href: "/profile"
}, " Profile ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"white"},
  class: "header-dropdown"
}, " Log Out ", -1)
const _hoisted_4 = { style: {"position":"relative"} }
const _hoisted_5 = {
  key: 0,
  class: "notification"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","width":"100%","padding":"10px","line-height":"35px","background":"#2e3191","color":"white","font-size":"20px","border-radius":"20px 20px 0 0"} }, " Notifications ", -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_10 = { style: {"color":"gray"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_BellFilled = _resolveComponent("BellFilled")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_MessageOutlined = _resolveComponent("MessageOutlined")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_a_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { style: {"background-color":"#44c4f3"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "0" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { onClick: _ctx.logout }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", {
          class: "logged-user ant-dropdown-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          style: {"color":"white","float":"right"}
        }, [
          _createVNode(_component_UserOutlined),
          _createTextVNode(" " + _toDisplayString(_ctx.auth_vendor.vendor_name), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_space, { style: {"float":"right"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BellFilled, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openNotif = !_ctx.openNotif)),
            style: {"cursor":"pointer"}
          }),
          _createVNode(_component_a_badge, {
            style: {"position":"relative","top":"-4px","left":"-4px","cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openNotif = !_ctx.openNotif)),
            count: _ctx.notificationCount,
            "number-style": {
                  backgroundColor: 'rgb(255 41 6)',
                  color: 'white',
                  boxShadow: 'rgb(167 18 18) 0px 0px 0px 1px inset',
                }
          }, null, 8, ["count", "number-style"]),
          (_ctx.openNotif)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allNotification, (notif, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["notif", notif.is_read ? '' : 'notifUnread']),
                    onClick: ($event: any) => (_ctx.goToNotif(notif))
                  }, [
                    _createVNode(_component_MessageOutlined),
                    _createElementVNode("b", null, "  " + _toDisplayString(notif.description), 1),
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("small", _hoisted_10, _toDisplayString(notif.date), 1)
                  ], 10, _hoisted_7))
                }), 128)),
                _createElementVNode("div", {
                  class: "notif",
                  style: {"cursor":"pointer","text-align":"center","font-weight":"bold","border-radius":"0 0 20px 20px"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToNotifications(_ctx.notif)))
                }, " See more ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}